export default __webpack_public_path__ + "static/media/Vaedus.09cbb06a.jpg";